<template>
  <div>
    <svg
      class="spinner"
      :width="size"
      :height="size"
      :viewBox="`0 0 ${size} ${size}`"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        class="path"
        fill="none"
        :stroke-width="stroke"
        :cx="size / 2"
        :cy="size / 2"
        :r="size / 2 - stroke / 2"
      />
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'Spinner',
    computed: {
      size() {
        return 20;
      },
      stroke() {
        return 2;
      },
    },
  };
</script>


<style scoped>

  .spinner {
    animation: rotator 1.4s linear infinite;
  }

@keyframes rotator {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(270deg); }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 90;
  }
  50% {
    stroke-dashoffset: 46.75;
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: 90;
    transform: rotate(450deg);
  }
}

.path {
  stroke: #666;
  stroke-dasharray: 100;
  stroke-dashoffset: 0;
  transform-origin: center;
  animation: dash 1.4s ease-in-out infinite;
}

</style>
